module.exports = "<div class=\"add-inventory-panel\">\n  <add-inventory day=\"day\" date=\"date\" venue=\"venue\" type=\"type\" schedule=\"schedule\" enable=\"enable\" inventory=\"inventory\" cancel=\"close\" on-added-or-updated=\"onAddedOrUpdated\"></add-inventory>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/panels/addInventory/template.html
// module id = 1264
// module chunks = 0